"use client"; // This is a client component 👈🏽

import TopNav from "./topNav";

export default function Footer() {
    return (
        <TopNav />
    )
}